<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <h5 class="mt-2 mb-3">Ingresar los datos solicitados</h5>
        </div>
      </div>
      <div class="row w-100">
        <div class="col-2">
          <ui-select
            class="w-100"
            has-search
            multiple
            label="Puerto Embarque"
            placeholder="Seleccionar"
            :options="puertos"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            @change="habilitarBtn"
            v-model="formulario.puertosEmbarqueBusquedaModel"
          />
        </div>

        <div class="col-2">
          <ui-select
            class="w-100"
            has-search
            multiple
            label="Puerto Destino"
            placeholder="Seleccionar"
            :options="puertos"
            :keys="{ value: 'id', label: 'name' }"
            searchPlaceholder="Buscar"
            @change="habilitarBtn"
            v-model="formulario.puertosBusquedaModel"
          />
        </div>

      </div>
      <div class="row w-100">
        <div class="col-2">
          <ui-select
            class="w-100"
            has-search
            label="Año"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="options.dataListaAnios"
            :keys="{ value: 'value', label: 'label' }"
            @change="habilitarBtn(); getSemanasPorAnio();"
            v-model="formulario.anioBusquedaModel"
          />
        </div>
        <div class="col-2">
          <!-- Semana -->
          <ui-select
            class="w-100"
            has-search
            label="N° Semana"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :options="semanas"
            :keys="{ value: 'id', label: 'name' }"
            @change="habilitarBtn"
            v-model="formulario.numeroSemanaBusquedaModel"
          />
        </div>

        <div class="col-2">
          <!-- Semanas -->
          <ui-radio-group
            name="semanaBusquedaModel"
            class="w-100"
            :options="options.numSemanasOptions"
            v-model="formulario.semanaBusquedaModel"
            >Semanas</ui-radio-group
          >
        </div>

        <div class="col-2">
          <!-- Tipo de Carga -->
          <ui-radio-group
            name="tipoCargaBusquedaModel"
            class="w-100"
            :options="options.tipoCargaOptions"
            :keys="{ value: 'value', label: 'label' }"
            v-model="formulario.tipoCargaBusquedaModel"
            >Tipo de Carga</ui-radio-group
          >
        </div>

        <div class="col-3">
          <div class="d-flex w-100 mt-3">
            <Button
              :size="17"
              color="orange"
              colorText="#ffffff"
              tooltip="Buscar"
              icon="fas fa-search"
              round
              :width="36"
              class="mr-3"
              traslate
              @click.native="filtrarLista"
            />

            <Button
              :size="15"
              color="#28a745"
              colorText="#ffffff"
              tooltip="Exportar a Excel"
              icon="icon fas fa-file-excel"
              round
              :width="36"
              class="mr-3"
              @click.native="generarReporte"
              traslate
            />

            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Limpiar"
              icon="fas fa-trash"
              round
              :width="36"
              @click.native="clear"
              translate
            />
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// Constantes
import { getBookingsNoPlanificados, getBusquedaItinerariosSinLoading, getSemanasPorAnio, downloadReporteItinerario} from "../../../constants/lineas";

// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiRadioGroup from "keen-ui/src/UiRadioGroup";
import uuid from "keen-ui/src/helpers/uuid";
import Button from '../../common/Button'


const numSemanasOptions = [
  {
    label: "+1",
    value: 1,
  },
  {
    label: "+2",
    value: 2,
  },
  {
    label: "+3",
    value: 3,
  },
];

const tipoCargaOptions = [
  {
    label: "Reefer",
    value: 1,
  },
  {
    label: "Dry",
    value: 2,
  },
];

// Itinerario "fantasma" que se agrega cuando un servicio salta semanas
const BLANK_SAILING_TEXTO = "BLANK SAILING";
const BLANK_SAILING_FECHA = "0000-00-00";

// Índices de las columnas dentro de data del itinerario
const COLUMNA_SEMANA = 0;
const COLUMNA_NAVIERA = 1;
const COLUMNA_SERVICIO = 4;
const COLUMNA_PUERTO_EMBARQUE = 5;
const COLUMNA_PUERTO_DESTINO = 7;

const dataListaAnios = [
  {
    label: "2018",
    value: 2018,
  },
  {
    label: "2019",
    value: 2019,
  },
  {
    label: "2020",
    value: 2020,
  },
  {
    label: "2021",
    value: 2021,
  },
  {
    label: "2022",
    value: 2022,
  },
  {
    label: "2023",
    value: 2023,
  },
  {
    label: "2024",
    value: 2024,
  },
  {
    label: "2025",
    value: 2025,
  },
  {
    label: "2026",
    value: 2026,
  },
];


export default {
  props: ["dataCargaFecha"],
  data() {
    return {
      options: {
        numSemanasOptions,
        tipoCargaOptions,
        dataListaAnios,
      },
      formulario: {
        puertosBusquedaModel: [],
        puertosEmbarqueBusquedaModel: [],
        numeroSemanaBusquedaModel: {},
        anioBusquedaModel: "",
        tipoCargaBusquedaModel: 1,
        semanaBusquedaModel: 1,
      },
      anioActual: "",
      estadoBtn: false,

      isLoading: false,
      semanas: [],
    };
  },
  components: {
    UiSelect,
    UiRadioGroup,
    Button
  },
  computed: {
    ...mapState(["puertos"]),
    ...mapState("lineas", ["dataDatatableListarBusquedaItinerariosFiltrada","dataDatatableListarItinerariosPuertosEmbarque"]),
  },
  methods: {
    ...mapActions("lineas", [
      // "actionFilterDataListarBusquedaItinerarios",
      "actionLimpiarDataListarBusquedaItinerarios",
      "actionSetEstadoListarItinerarios",
      "actionSetDataListarBusquedaItinerarios",
      "actionSetDataContenedores",
      "actionSetEstadoSolicitudReservaPlanificada",
      "actionSetFormularioSolicitudNoPlanificada",
      "actionSetDataAnios",
      "actionSetDataSemanas",
      "actionSetDataPuertoDescarga",
      "actionSetDataserviciosIntegrales",
      "actionSetDataShippers",
      "actionSetDataShippersAddress",
      "actionSetDataProducts",
      "actionSetDataMetodosPago",
      "actionSetDataTarifaContrato",
      "actionSetListaProductosExportar",
      "actionSetListaShipper",
      "actionSetListaDireccionesShipper",
      "actionSetListaPacking",
      "actionSetListaConsignatarios",
      "actionSetListaNotificados",
      "actionSetListaAtmosferas",
      "ActionSetVisibleModalUtilizarReservaAnterior",
      "actionSetShippers",
      "actionSetLoadingTableItinerarySearch"
    ]),
    ...mapActions(["AccionCambiar", "ActionSetLoadingTable"]),

    habilitarBtn() {
      this.estadoBtn = this.formulario.puertosBusquedaModel.length > 0 || this.formulario.puertosEmbarqueBusquedaModel.length > 0 ;
    },

    // Itinerario "fantasma" que representa una semana sin recalada del servicio.
    // Conserva los datos que identifican al servicio (naviera, servicio y puertos)
    // para que la fila siga apareciendo al filtrar la tabla por ellos
    filaBlankSailing( semana, referencia ) {
      return {
        data: [
          semana,                                 // Semana
          referencia[COLUMNA_NAVIERA],            // Naviera
          BLANK_SAILING_TEXTO,                    // Nave
          BLANK_SAILING_TEXTO,                    // N° Viaje
          referencia[COLUMNA_SERVICIO],           // Servicio
          referencia[COLUMNA_PUERTO_EMBARQUE],    // Puerto Embarque
          BLANK_SAILING_TEXTO,                    // ETD
          referencia[COLUMNA_PUERTO_DESTINO],     // Puerto Destino
          BLANK_SAILING_FECHA,                    // ETA
          0,                                      // TT
        ],
        data_complementaria: {},
        blank_sailing: true,
      };
    },

    // Completa con itinerarios en BLANK SAILING las semanas intermedias que
    // un mismo servicio se salta (por ejemplo, si de la 39 pasa a la 41)
    completarSemanasBlankSailing( data_table ) {

      if ( !Array.isArray( data_table ) || data_table.length === 0 ) return data_table;

      // Semana de cada fila y semanas presentes en cada servicio
      const semanasFilas = data_table.map( fila =>
        fila && Array.isArray( fila.data ) ? parseInt( fila.data[COLUMNA_SEMANA] ) : NaN
      );

      const servicios = new Map();

      data_table.forEach( ( fila, indice ) => {

        if ( isNaN( semanasFilas[indice] ) ) return;

        const clave = [
          fila.data[COLUMNA_SERVICIO],
          fila.data[COLUMNA_PUERTO_EMBARQUE],
          fila.data[COLUMNA_PUERTO_DESTINO],
        ].join("|");

        if ( !servicios.has( clave ) ) {
          // La primera fila del servicio sirve de referencia para las fantasma
          servicios.set( clave, { referencia: fila.data, semanas: new Set() } );
        }

        servicios.get( clave ).semanas.add( semanasFilas[indice] );
      });

      // Semanas que cada servicio se salta
      const semanasFaltantes = [];

      servicios.forEach( servicio => {

        const semanas = [...servicio.semanas].sort( (a, b) => a - b );

        for ( let i = 1; i < semanas.length; i++ ) {
          for ( let semana = semanas[i - 1] + 1; semana < semanas[i]; semana++ ) {
            semanasFaltantes.push({ semana, referencia: servicio.referencia });
          }
        }
      });

      if ( semanasFaltantes.length === 0 ) return data_table;

      // Cada fila fantasma se inserta después de la última fila de una semana
      // anterior, para que quede entre medio de los demás servicios
      const fantasmas = new Map();

      semanasFaltantes.forEach( faltante => {

        let indiceAnterior = -1;

        semanasFilas.forEach( ( semanaFila, indice ) => {
          if ( !isNaN( semanaFila ) && semanaFila < faltante.semana ) indiceAnterior = indice;
        });

        if ( !fantasmas.has( indiceAnterior ) ) fantasmas.set( indiceAnterior, [] );

        fantasmas.get( indiceAnterior ).push( faltante );
      });

      fantasmas.forEach( faltantes => faltantes.sort( (a, b) => a.semana - b.semana ) );

      const agregarFantasmas = ( acumulado, indice ) => {
        const faltantes = fantasmas.get( indice ) || [];
        faltantes.forEach( ({ semana, referencia }) =>
          acumulado.push( this.filaBlankSailing( semana, referencia ) )
        );
        return acumulado;
      };

      return data_table.reduce( ( acumulado, fila, indice ) => {
        acumulado.push( fila );
        return agregarFantasmas( acumulado, indice );
      }, agregarFantasmas( [], -1 ) );
    },

    async filtrarLista() {

      if ( this.formulario.puertosBusquedaModel.length == 0 && this.formulario.puertosEmbarqueBusquedaModel.length == 0 ) {
        return this.$vToastify.error("Se debe seleccionar al menos un puerto", `Error en Puertos`);
      }

      this.actionSetLoadingTableItinerarySearch( true );

      const { data_table } = await getBusquedaItinerariosSinLoading( this.formulario );

      this.actionSetDataListarBusquedaItinerarios( this.completarSemanasBlankSailing( data_table ) );

      this.actionSetLoadingTableItinerarySearch( false );
    },

    async generarReporte() {

      if ( this.formulario.puertosBusquedaModel.length === 0 && this.formulario.puertosEmbarqueBusquedaModel.length === 0 ) {
        return this.$vToastify.error("Se debe seleccionar al menos un puerto", `Error en Puertos`);
      }

      if (this.formulario.anioBusquedaModel === "") {
        return this.$vToastify.error("Se debe seleccionar un año", `Error en Año`);
      }

      if (this.formulario.numeroSemanaBusquedaModel === "") {
        return this.$vToastify.error("Se debe seleccionar una semana", `Error en Semana`);
      }

      if (this.formulario.semanaBusquedaModel === "") {
        return this.$vToastify.error("Se debe seleccionar la cantidad de semanas", `Error en Semanas`);
      }

      if (this.formulario.tipoCargaBusquedaModel === "") {
        return this.$vToastify.error("Se debe seleccionar el tipo de carga", `Error en Tipo de Carga`);
      }

      this.$vToastify.loader("Generando reporte de itinerarios...");


      let filters = {
        id_ports: this.formulario.puertosBusquedaModel.map(p => p.id) ?? [],
        chargin_ports: this.formulario.puertosEmbarqueBusquedaModel.map( p => p.id ) ?? [],
        anio: this.formulario.anioBusquedaModel.value ?? null,
        container_type: this.formulario.tipoCargaBusquedaModel ?? null,
        semana: this.formulario.numeroSemanaBusquedaModel.id ?? null,
        semanas_mas: this.formulario.semanaBusquedaModel ?? null
      };

      await downloadReporteItinerario(filters, uuid.short("reporte-itinerarios-ucc-"));

      this.$vToastify.stopLoader();

    },

    async filtrarListaWacth() {

      this.actionLimpiarDataListarBusquedaItinerarios();
      const { data_table } = await getBusquedaItinerariosSinLoading( this.formulario );
      this.actionSetDataListarBusquedaItinerarios( this.completarSemanasBlankSailing( data_table ) );

    },

    numeroDeSemana ( fecha ) {
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24,
        DIAS_QUE_TIENE_UNA_SEMANA = 7,
        JUEVES = 4;
      
      fecha = new Date(
        Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
      );
      
      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }
      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);
      const inicioDelAño = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));
      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAño;
      return Math.ceil(
        (diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS + 1) /
          DIAS_QUE_TIENE_UNA_SEMANA
      );
    },
    obtenerFechaActual() {
      // Obtener año actual

      let fechaActual = new Date();
      let anioActual = fechaActual.getFullYear();

      this.formulario.anioBusquedaModel = anioActual;

      // Obtener numero de semana actual

      const numeroDeSemana = (fecha) => {
        const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24,
          DIAS_QUE_TIENE_UNA_SEMANA = 7,
          JUEVES = 4;
        fecha = new Date(
          Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
        );
        let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
        if (diaDeLaSemana === 0) {
          diaDeLaSemana = 7;
        }
        fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);
        const inicioDelAño = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));
        const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAño;
        return Math.ceil(
          (diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS + 1) /
            DIAS_QUE_TIENE_UNA_SEMANA
        );
      };
      const numeroDeSemanaActual = numeroDeSemana(new Date());

      this.formulario.numeroSemanaBusquedaModel = {
        id: numeroDeSemanaActual.toString(),
        name: numeroDeSemanaActual.toString(),
      };

      this.formulario.anioBusquedaModel = {
        label: anioActual.toString(),
        value: anioActual,
      };
    },

    clear() {
      this.estadoBtn = false;
      this.formulario.puertosBusquedaModel = [];
      this.formulario.puertosEmbarqueBusquedaModel = [];
      this.formulario.anioBusquedaModel = "";
      this.formulario.numeroSemanaBusquedaModel = "";

      this.actionLimpiarDataListarBusquedaItinerarios();
      this.actionSetEstadoListarItinerarios(false);

      this.obtenerFechaActual();
    },

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
    async getDataInit(){
      const semana = this.numeroDeSemana(new Date());

      const form = {
        puertosBusquedaModel: [],
        puertosEmbarqueBusquedaModel: [],
        anioBusquedaModel: {
          value : (new Date).getFullYear()
        } ,
        tipoCargaBusquedaModel: 1,
        numeroSemanaBusquedaModel: {
          id: semana
        },
        semanaBusquedaModel: 1
      };

      this.actionSetLoadingTableItinerarySearch( true );
      const { data_table } = await getBusquedaItinerariosSinLoading( form );
      this.actionSetDataListarBusquedaItinerarios( this.completarSemanasBlankSailing( data_table ) );

      this.actionSetLoadingTableItinerarySearch( false );

    },
    async getDataFormulario() {

      let data = await getBookingsNoPlanificados();

      this.actionSetDataAnios(data.filtroAnios);
      this.actionSetDataSemanas(data.filtroSemanas);
      this.actionSetDataContenedores(data.filtro_contenedores);
      this.actionSetDataPuertoDescarga(data.filtro_puertos);

      this.actionSetDataShippers(data.filtroShippers);
      this.actionSetDataShippersAddress(data.filtroShippersAddress);
      this.actionSetDataProducts(data.filtroProducts);
      this.actionSetDataMetodosPago(data.filtroMetodosPago);
      this.actionSetDataserviciosIntegrales(data.listaServiciosIntegrales);
      this.actionSetDataTarifaContrato(data.filtroTarifaContrato);
      this.actionSetListaProductosExportar(data.listaProductosExportar);
      this.actionSetListaShipper(data.listaShippers);
      this.actionSetListaPacking(data.listaPackings);
      this.actionSetListaDireccionesShipper(data.listaDireccionesShippers);

      this.actionSetListaConsignatarios(data.listarConsignatarios);
      this.actionSetListaNotificados(data.listarNotificados);
      this.actionSetListaAtmosferas(data.listaAtmosferas);
      this.actionSetShippers(data.shippers);
      
    },
    async getSemanasPorAnio( ){

      if( this.formulario.anioBusquedaModel.value !== undefined ){
        const anio = parseInt( this.formulario.anioBusquedaModel.value ) ;

        const { data } = await getSemanasPorAnio(anio);
        this.semanas = data.map( d => ({
          id : d.id.toString(),
          name : d.name.toString()
        })) ;
        return data ;
      }
    }
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
  },
  mounted() {
    this.obtenerFechaActual();
    this.getSemanasPorAnio();
    this.getDataInit();
    this.getDataFormulario();
  },

  watch : {

    dataDatatableListarItinerariosPuertosEmbarque : function(_new){
      _new && this.filtrarListaWacth();
    }

  }
};
</script>
